(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("apiCore"));
	else if(typeof define === 'function' && define.amd)
		define(["apiCore"], factory);
	else if(typeof exports === 'object')
		exports["apiAdmin"] = factory(require("apiCore"));
	else
		root["apiAdmin"] = factory(root["apiCore"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3f1b__) {
return 